const state = {
  type: 'bilateral',
  diplomacy: 'Memorandum of Understanding',
};

const mutations = {
  setType(state, type) {
    state.type = type;
  },
  setDiplomacy(state, input) {
    state.diplomacy = input;
  },
};

const actions = {
  updateType({ commit }, type) {
    commit('setType', type);
  },
  updateDiplomacy({ commit }, input) {
    commit('setDiplomacy', input);
  },
};

const getters = {
  diplomacyType: state => state.type,
  selectedDiplomacy: state => state.diplomacy,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
